import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'sortByReference'})
export class SortByReferencePipe implements PipeTransform {
  transform(
    sourceArray: any[],
    referenceArray: any[],
    sourceKey: string,
    referenceKey: string = sourceKey
  ): any[] {

    if (!sourceArray || !referenceArray || !sourceKey) {
      return sourceArray;
    }

    // Create lookup map from reference array
    const orderMap = new Map(
      referenceArray.map((item, index) => [item[referenceKey], index])
    );

    // Sort source array based on reference order
    return [...sourceArray].sort((a, b) => {
      const aIndex = orderMap.get(a[sourceKey]);
      const bIndex = orderMap.get(b[sourceKey]);

      // If key not found in reference array, push to end
      if (aIndex === undefined) return 1;
      if (bIndex === undefined) return -1;

      return aIndex - bIndex;
    });
  }
}
